<div class="area-login-backgraound"></div>

<div class="area-form">
  <div class="login-container">
    <div class="login-box">

      <img 
        class="img-logo-login"
        src="../../../assets/MIV/brand/versao 1.png"
        alt="Logo Control PS"
      />

      <h2>Entre para continuar</h2>

      <form (submit)="login(); $event.preventDefault()">

        <label>Email</label>
        <input 
          type="email"
          [(ngModel)]="email"
          name="email"
          required
        />

        <label>Senha</label>
        <input 
          type="password"
          [(ngModel)]="password"
          name="password"
          required
        />

        <button [disabled]="loading">
          {{ loading ? 'Entrando...' : 'Entrar' }}
        </button>

        <p class="info" *ngIf="infoMessage">
          {{ infoMessage }}
        </p>

        <p class="error" *ngIf="errorMessage">
          {{ errorMessage }}
        </p>

      </form>
    </div>
  </div>
</div>
